module.exports = __webpack_public_path__ + "img/engagement-photo-3.2d69967a.jpg";